import {
  KlevuFetch,
  type KlevuFetchQueries,
  type KlevuResponseObject,
} from "@klevu/core";
import type { ShallowRef } from "vue";
import type { KlevuDataMapper } from "~/modules/klevu/types/KlevuDataMapper";
import type { MappedKlevuResult } from "~/modules/klevu/types/MappedKlevuResult";

export function useKlevu() {
  const klevuConfig = useKlevuConfig();
  const res: ShallowRef<KlevuResponseObject | undefined> =
    shallowRef(undefined);

  async function fetch(
    ...functionPromises: KlevuFetchQueries
  ): Promise<KlevuResponseObject> {
    const klevuFunctions = await Promise.all(functionPromises);
    klevuFunctions.forEach((f) => (f.configOverride = klevuConfig));
    const response = await KlevuFetch(...functionPromises);
    if (response?.apiResponse?.meta?.error) {
      throw new Error(
        "Search execution error: " + response.apiResponse.meta.error.message,
      );
    }
    return (res.value = response);
  }

  function mapQueryResult<M extends KlevuDataMapper<any>>(
    queryId: string,
    mapper: M,
  ): MappedKlevuResult<ReturnType<M>> | undefined {
    const queryResult = res.value?.queriesById(queryId);

    if (!queryResult) {
      return undefined;
    }

    return {
      meta: queryResult.meta,
      filters: queryResult.filters,
      mappedRecords: queryResult.records.map((item) => mapper(item)),
    };
  }

  return {
    fetch,
    mapQueryResult,
    res: res as Readonly<ShallowRef<KlevuResponseObject | undefined>>,
  };
}
